import { render, staticRenderFns } from "./Upgraded.vue?vue&type=template&id=aca7441a&scoped=true&"
import script from "./Upgraded.vue?vue&type=script&lang=js&"
export * from "./Upgraded.vue?vue&type=script&lang=js&"
import style0 from "./Upgraded.vue?vue&type=style&index=0&id=aca7441a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca7441a",
  null
  
)

export default component.exports